import { useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";
const OC = { care: "#10b981", utility: "#3b82f6", creative: "#a855f7", extraction: "#ef4444" };

export const ResearchTicker = () => {
  const [papers, setPapers] = useState([]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.post(`${API}/research/papers`, { sort: "year", limit: 20, page: 1 });
        setPapers(res.data.papers || []);
      } catch (e) { /* silent */ }
    };
    fetch();
  }, []);

  if (papers.length === 0) return null;

  // Double the items for seamless infinite scroll
  const items = [...papers, ...papers];

  const duration = papers.length * 4;

  return (
    <div className="relative overflow-hidden bg-black/20 border-b border-cyan-500/10 h-7 flex items-center" data-testid="research-ticker">
      <div className="flex-shrink-0 px-3 flex items-center gap-1.5 bg-cyan-500/10 h-full border-r border-cyan-500/10 z-10">
        <span className="w-1.5 h-1.5 rounded-full bg-cyan-400 animate-pulse" />
        <span className="text-[9px] font-bold text-cyan-400 uppercase tracking-wider whitespace-nowrap">Research Feed</span>
      </div>
      <div className="overflow-hidden flex-1">
        <div className="flex items-center gap-8 ticker-scroll"
          style={{ animation: `ticker-move ${duration}s linear infinite` }}>
          {items.map((p, i) => (
            <div key={i} className="flex items-center gap-2 flex-shrink-0 whitespace-nowrap">
              <span className="w-1.5 h-1.5 rounded-sm rotate-45 flex-shrink-0" style={{ background: OC[p.value_orientation] || "#64748b" }} />
              <span className="text-[10px] text-slate-300 font-medium max-w-[300px] truncate">{p.paper_title}</span>
              <span className="text-[8px] text-slate-500">{p.source === "semantic_scholar" ? "S2" : "arXiv"}</span>
              <span className="text-[8px] px-1.5 py-0.5 rounded-full" style={{ background: `${OC[p.value_orientation] || "#64748b"}15`, color: OC[p.value_orientation] || "#64748b" }}>
                {p.value_orientation}
              </span>
              {p.citations > 0 && <span className="text-[8px] text-cyan-400/50">{p.citations} cites</span>}
              <span className="text-slate-600 mx-1">|</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
